import TaxReturnSubmissionAPI from '@/api/TaxReturnSubmissionAPI.js';
import EconomicTaxReturnSubmissionAPI from '@/api/EconomicTaxReturnSubmissionAPI.js';
import DecFileAPI from '@/api/DecFileAPI.js';
import httpClient from '../../../api/axios-httpclient';

export default {
	getTaxReturnsSubmission: async function(context, param) {
		//Gán cờ loading
		context.commit('updateLoading', true);

		//Gọi dữ liệu
		let res = await httpClient.postAsync(
			{
				url: TaxReturnSubmissionAPI.getAPIUrl() + '/paging',
				data: param
			},
			false,
			false
		);

		//Xử lý thành công
		context.commit('updateTaxReturnsSumission', res.Data);
		context.commit('updateQuickSearchText', param.Text);

		//Gán cờ loading
		context.commit('updateLoading', false);
		return res;
	},

	/**
	 * thực hiện nộp tờ khai thuế
	 */
	submitDeclaration: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: TaxReturnSubmissionAPI.getAPIUrl() + '/submitdecv2',
				data: payload
			},
			true
		);

		// Trả kết quả ra ngoài
		return res;
	},

	getAppendixTaxReturnsSubmission: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: TaxReturnSubmissionAPI.getAPIUrl() + '/getbyparentid',
			params: payload
		});

		if (res && res.Success && res.Data) {
			context.commit('updateAppendixData', res.Data);
		} else {
			return [];
		}
	},

	getTaxReturnsSubmissionById: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: TaxReturnSubmissionAPI.getAPIUrl() + '/getbyid',
			params: payload
		});

		if (res && res.Success && res.Data) {
			return res.Data;
		} else {
			return null;
		}
	},
	getTaxReturnSubmissionHitoriesPaging: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: TaxReturnSubmissionAPI.getAPIUrl() + '/historypaging',
			data: payload
		});

		if (res && res.Success && res.Data) {
			context.commit(
				'updateTaxReturnSubmissionHistoriesPagingData',
				res.Data
			);
		} else {
			return [];
		}
	},
	setEmptyTaxReturnSubmissionHitoriesPaging: function(context, payload) {
		context.commit('updateEmptyTaxReturnSubmissionHitoriesPaging', []);
	},
	/**
	 * Kiểm tra xem tờ khai có được phép nộp phụ lục hay không
	 */
	validateAppendix: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: TaxReturnSubmissionAPI.getAPIUrl() + '/validateappendix',
			data: payload
		});

		// Trả kết quả ra ngoài
		if (res && res.Success) {
			return res.Data;
		}

		return null;
	},

	previewNotification: async function(context, notification) {
		let res = await httpClient.postAsync({
			url: TaxReturnSubmissionAPI.getAPIUrl() + '/previewnotification',
			data: notification
		});

		if (res.Success && res.Data) {
			return DecFileAPI.getAPIUrl() + '/getnotification?key=' + res.Data;
		}

		return null;
	},

	exportReportData: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: TaxReturnSubmissionAPI.getAPIUrl() + '/exportreportdata',
			data: payload
		});

		if (res.Success && res.Data) {
			return (
				DecFileAPI.getAPIUrl() +
				'/exporttaxreturnsubmissionispaidlistreport?key=' +
				res.Data
			);
		}

		return null;
	},

	getTaxReturnHavePaidReportData: async function(context, payload) {
		let url = TaxReturnSubmissionAPI.getAPIUrl() + '/getreportdata';
		let res = await httpClient.postAsync(
			{
				url: url,
				data: payload
			},
			true
		);

		if (res.Success) {
			context.commit('updateTaxReturnHavePaidReportData', res.Data);
		} else {
			context.commit('updateTaxReturnHavePaidReportData', {});
		}
	},

	/// Lấy thông tin khoản thu phải nộp trên tờ khai
	getDetailTaxpaper: async function(context, payload) {
		let res = await httpClient.postAsync({
			url:
				EconomicTaxReturnSubmissionAPI.getAPIUrl() +
				'/getdetailtaxpaper',
			data: payload
		});

		return res;
	},

	/// Lấy thông tin khoản thu phải nộp trên tờ khai từ submissionId của tờ khai
	getDetailTaxpaperBySubmissionId: async function(context, payload) {
		let res = await httpClient.getAsync({
			url:
				EconomicTaxReturnSubmissionAPI.getAPIUrl() +
				'/getdetailtaxpaperbysubmissionId',
			params: payload
		});

		return res;
	}
};
